import AddIcon from "@mui/icons-material/Add";
import type {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import type {FidelioConfig} from "crqlar-react-common/dist/models/integrations/fidelio/fidelio.config";
import {FidelioTaskService} from "crqlar-react-common/dist/services/integrations/fidelio/fidelioTask.service";
import {useTranslation} from "react-i18next";
import SyncTasksTable from "../../common/SyncTasksTable";

interface Props {
    configData: UseEntityData<FidelioConfig>
}

const FidelioTasks = ({configData}: Props) => {
    const {t} = useTranslation();
    const configId = configData.item.id;

    return (
        <SyncTasksTable
            configId={configId}
            tableId="system-fidelio-sync-tasks"
            list={FidelioTaskService.getAll}
            actions={[{
                id: 'btn-schedule-full-sync',
                label: t('Schedule full sync'),
                startIcon: <AddIcon/>,
                onClick: () => FidelioTaskService.scheduleFullSync(configId!)
            }]}
        />
    );
};

export default FidelioTasks;
